import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsComponent } from './components.component';
import { MapsideComponent } from './mapside/mapside.component';
import { AppSharedMapComponent } from './map/map.component';
import { SharedMapService, SelectableService, AttributToTextService, NullToEmptyString } from './../../_services/index';
import { AppSharedMapPopupComponent } from './popup/popup.component';
import { ConsoleWindowComponent } from './consolewindow/consolewindow.component';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { FormsModule } from "@angular/forms";
import { PrecizionServices, ExportPdfService } from './../../_services/index';
import { ExportwindowComponent } from './exportwindow/exportwindow.component';
import { LoadingService } from '../../framework/auth/components/loading/loading.service';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DuplicatePreconisationComponent } from './farmerprevis/duplicatepreconisation.component';
import { UpdateFarmerPrevisComponent } from './farmerprevis/updatefarmerprevis.component';
import { PopinProductCompositionsComponent } from './popin/product-composition/popin-product-compositions.component';
import { ButtonProductCompositionsComponent } from './popin/product-composition/button-product-compositions.component';
import { DeviceswindowComponent } from './devices-window/deviceswindow.component';
import { GroupComboxComponent } from './combox/groupCombox.component';
import { ExportConnectedStatesComponent } from './connectedstates/exportconnectedstates.component';
import { ClickOutsideDirective } from '../../_directives/ClickOutSideDirective';
@NgModule({
  imports: [
    CommonModule,
    WindowModule,
    ButtonsModule,
    GridModule,
    DropDownsModule,
    TooltipModule,
    FormsModule,
    InputsModule,
    ClickOutsideDirective
      
  ],

  declarations: [ComponentsComponent, MapsideComponent, AppSharedMapComponent, NullToEmptyString, AppSharedMapPopupComponent,ExportConnectedStatesComponent, ConsoleWindowComponent, ExportwindowComponent, DuplicatePreconisationComponent,UpdateFarmerPrevisComponent, ButtonProductCompositionsComponent,PopinProductCompositionsComponent,DeviceswindowComponent,GroupComboxComponent],
  exports: [
    AppSharedMapComponent,
    MapsideComponent,
    NullToEmptyString,
    ConsoleWindowComponent,
    ExportwindowComponent,
    DuplicatePreconisationComponent,
    PopinProductCompositionsComponent,
    ButtonProductCompositionsComponent,
    UpdateFarmerPrevisComponent,
    DeviceswindowComponent,
    ExportConnectedStatesComponent
  ],
  providers: [SharedMapService, SelectableService, AttributToTextService, PrecizionServices, ExportPdfService, LoadingService]
})
export class ComponentsModule { }
